import React, { useState } from 'react'
import { GxForm, GxIcon } from '@garpix/garpix-web-components-react'
import IconButton from '@/components/Button/IconButton'
import Input from '@/components/Input'
import { IPropsWorksSearch } from '../interfaces'
import { searchIcon } from '@/images'
import style from '../styles/contest_detail.module.scss'

const WorksSearch = ({
  initValue = '',
  inputDisabled = false,
  search = () => {}
}: IPropsWorksSearch): React.ReactElement => {
  const [inputValue, setInputValue] = useState(initValue)

  const onInput = (e): void => {
    const { value = '' } = e.target
    setInputValue(value)
  }

  const onSubmit = (): void => {
    search({ q: inputValue })
  }
  return (
    <GxForm onGx-submit={onSubmit}>
      <Input
        type='text'
        theme='secondary'
        disabled={inputDisabled}
        placeholder='Поиск...'
        className={style.search__input}
        value={inputValue}
        onGx-input={onInput}
      >
        <IconButton
          type='submit'
          theme='red'
          size='medium'
          slot='suffix'
          className={style.search__button}
        >
          <GxIcon src={searchIcon} className={style.search__button_icon} />
        </IconButton>
      </Input>
    </GxForm>
  )
}

export default WorksSearch
